module.exports = __webpack_public_path__ + "img/major-credit-cards.5bb7f6de.png";